import { usePermissions } from 'features/permissions/usePermissions';
import { useFeatureFlag } from 'features/feature-set/useFeatureFlag';
import { PermissionTypes } from 'features/permissions/types';
import { useAppSelector } from 'store/hooks';
import { selectQAUpvoteEnabled } from 'features/qa/qaSlice';
import { canAccessQA } from 'features/qa/canAccessQA';
import { useSystemSession } from 'hooks/useSystemSession';

export const useQA = () => {
  const { hasPermissions } = usePermissions();
  const isFeatureEnabled = useFeatureFlag('qa');
  const isSystemSession = useSystemSession();

  const upvoteEnabled = useAppSelector(selectQAUpvoteEnabled);

  const canAccessQa = hasPermissions(PermissionTypes.accessQa);
  const canAskQuestion = hasPermissions(PermissionTypes.askQuestionQa);
  const canAnswer = hasPermissions(PermissionTypes.answerQA);
  const canModerate = hasPermissions(PermissionTypes.moderateQA);
  const canUpvote = hasPermissions(PermissionTypes.upvoteQA);
  const canSeeQuestionsAuthor = hasPermissions(PermissionTypes.seeQuestionsAuthor);

  const isFeatureAvailable = canAccessQA({
    qaEnabled: isFeatureEnabled,
    canAccessQa,
    isSystemSession,
  });

  return {
    isFeatureAvailable,
    canAnswer,
    canAskQuestion,
    canModerate,
    canUpvote,
    upvoteEnabled,
    canSeeQuestionsAuthor,
    readOnly: isSystemSession,
  };
};
